export const ACCENT_STORAGE_KEY = "sigma-accent";

export const ACCENT_IDS = [
	"cerulean",
	"bitcoin",
	"matrix",
	"graphite",
	"orchid",
	"gold",
] as const;

export type AccentId = (typeof ACCENT_IDS)[number];

export const DEFAULT_ACCENT: AccentId = "cerulean";

export const ACCENT_PRESETS: Record<
	AccentId,
	{ label: string; swatch: string }
> = {
	cerulean: { label: "Cerulean", swatch: "oklch(0.52 0.11 232)" },
	bitcoin: { label: "Bitcoin", swatch: "oklch(0.62 0.16 55)" },
	matrix: { label: "Matrix", swatch: "oklch(0.55 0.16 145)" },
	graphite: { label: "Graphite", swatch: "oklch(0.5555 0 0)" },
	orchid: { label: "Orchid", swatch: "oklch(0.58 0.16 330)" },
	gold: { label: "Gold", swatch: "oklch(0.68 0.13 85)" },
};

export function isAccentId(value: string): value is AccentId {
	return (ACCENT_IDS as readonly string[]).includes(value);
}

export function parseAccentId(value: string | null | undefined): AccentId {
	if (value && isAccentId(value)) {
		return value;
	}
	return DEFAULT_ACCENT;
}

export function applyAccent(id: AccentId): void {
	document.documentElement.dataset.accent = id;
}

export const ACCENT_BOOTSTRAP_SCRIPT = `(function(){try{var a=localStorage.getItem(${JSON.stringify(ACCENT_STORAGE_KEY)});if(a&&/^(cerulean|bitcoin|matrix|graphite|orchid|gold)$/.test(a)){document.documentElement.setAttribute("data-accent",a);}}catch(e){}})();`;
